module.exports = __webpack_public_path__ + "img/logo-v2.c2f963d4.png";